export const getCompanyProfileState = (response) => ({
  effectiveCompany: response.effectiveCompany || response.company,
  pendingProfile: response.pendingProfile || null,
  pendingProposalId: response.pendingProposalId || null,
  proposalRevision: response.proposalRevision ?? null,
});

export const serializeCompanyProfile = (details) => {
  const patch = {...details};
  ['logoId', 'country', 'group'].forEach((field) => {
    if (patch[field] && typeof patch[field] === 'object') patch[field] = patch[field]._id;
  });
  return patch;
};

const deletionMessages = {
  COMPANY_HAS_LINKED_POSTS: 'This company has linked articles and cannot be deleted.',
  COMPANY_HAS_COMPANY_USERS: 'This company has company accounts and cannot be deleted.',
  COMPANY_HAS_CHAT: 'This company has conversations and cannot be deleted.',
  COMPANY_HAS_CLOUD_DATA: 'This company has cloud files and cannot be deleted.',
  COMPANY_ABOUT_MISMATCH: 'The linked About page does not belong to this company. Please reload and check its links.',
  COMPANY_DELETE_CONCURRENT_CHANGE: 'The company changed during deletion. Please reload and try again.',
};

export const getCompanyDeletionMessage = (message) => deletionMessages[message] || message;
